module.exports = __webpack_public_path__ + "static/media/f94fe446-9e01-47ca-a929-1b83dd809bb7.0a6bb62d.JPG";